const MIN_ZOOM = 0.01;
const MAX_ZOOM = 8;

export const clampZoom = (zoom) => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, zoom));

export const fitViewportToContainer = (docWidth, docHeight, containerWidth, containerHeight, padding = 32) => {
  if (!docWidth || !docHeight || !containerWidth || !containerHeight) {
    return { zoom: 1, x: 0, y: 0 };
  }

  const availableW = Math.max(1, containerWidth - padding * 2);
  const availableH = Math.max(1, containerHeight - padding * 2);
  const zoom = Math.min(MAX_ZOOM, Math.min(availableW / docWidth, availableH / docHeight));
  const x = (containerWidth - docWidth * zoom) / 2;
  const y = (containerHeight - docHeight * zoom) / 2;

  return { zoom, x, y };
};

export const zoomAtPoint = (viewport, nextZoom, pointX, pointY) => {
  const zoom = clampZoom(nextZoom);
  const scale = zoom / (viewport.zoom || 1);
  return {
    zoom,
    x: pointX - (pointX - viewport.x) * scale,
    y: pointY - (pointY - viewport.y) * scale,
  };
};

export const panBy = (viewport, dx, dy) => ({
  ...viewport,
  x: viewport.x + dx,
  y: viewport.y + dy,
});
